/* eslint-disable max-len */
import {
  // react,
  // redux,
  // jobitTop,
  // jobitFigma,
  // jobitSlide1,
  // jobitSlide2,
  // jobitSlide3,
  // morentSlide1,
  // morentSlide2,
  // morentSlide3,
  // morentProb,
  // morentFigma,
  // nextjs,
  // nodeJs,
  // mongodb,
  // morentTop,
  decisionTop,
  nextjs,
  tailwind,
  git,
  jobitProb,
  clerk,
  prisma,
  decisionSlide1,
  decision1,
  decisionSlide2,
} from '../assets';

export const caseStudies = [
  {
    id: '1',
    title: 'Decision Maker',
    description:
      'The application allows users to create decisions, define evaluation criteria, assign importance weights (1–10), and score each option.Based on the weighted scores, the system automatically calculatesthe best choice, helping users make more structured and objective decisions.',
    role: 'Software Engineer',
    textColor: 'text-[#5b3de6]',
    color: 'bg-[#5b3de6]',
    hoverColor: 'hover:text-[#5b3de6] dark:hover:text-[#5b3de6]',
    tech: [
      {
        id: 'decision-tech-1',
        name: 'NextJS',
        icon: nextjs,
      },
      {
        id: 'decision-tech-2',
        name: 'Prisma',
        icon: prisma,
      },
      {
        id: 'decision-tech-3',
        name: 'Clerk',
        icon: clerk,
      },
      {
        id: 'decision-tech-4',
        name: 'Tailwind',
        icon: tailwind,
      },
      {
        id: 'decision-tech-5',
        name: 'Git',
        icon: git,
      },
    ],
    demoLink: 'https://decision-app-next.vercel.app/',
    heroAsset: decisionTop,
    problemStatement: {
      problem:
        'Choosing between multiple options can be challenging, especially when many factors need to be considered. People often rely on intuition instead of structured evaluation,which can lead to inconsistent or biased decisions.',
      solution:
        'Decision Maker solves this problem by providing a structured decision-making system. Users can define criteria, assign importance weights (1–10), rate options, and automatically calculate the best result using weighted scoring.',
    },
    problemAsset: jobitProb,
    // figmaDesign: jobitFigma,
    processOverview:
      'In developing Decision Maker, I approached the project iteratively, building and refining features step by step. The app’s main goal was to help users make more objective decisions by creating options, defining criteria, assigning weights, and calculating weighted scores.',
    definition:
      'The Definition phase focused on understanding the purpose and scope of the app. I identified the core problem—helping users make objective decisions—and clarified the main features required: creating decisions, adding options and criteria, assigning weights, and calculating weighted scores. This step ensured the project had a clear direction before moving on to planning and development.',
    planning:
      'I planned the architecture and selected the tech stack: Next.js 16 for the frontend, Prisma with PostgreSQL for the database, Clerk for authentication, and Tailwind CSS for a modern, responsive design.',
    development:
      'Development was iterative. I implemented user authentication, created the CRUD logic for decisions, options, and criteria, and built the weighted score calculations along with dynamic results visualization. Each feature was tested to ensure smooth functionality, responsiveness, and a clear user flow.',
    delivery:
      'Finally, the MVP was deployed on Vercel, providing a live demo for testing and showcasing. The workflow—from creating a decision to evaluating the best option—was designed to be intuitive and visually clear, highlighting how users can make informed choices quickly.',
    product: [
      {
        id: 'decision-slide-1',
        asset: decision1,
      },
      {
        id: 'decision-slide-2',
        asset: decisionSlide1,
      },
      {
        id: 'decision-slide-3',
        asset: decisionSlide2,
      },
    ],
    learnings: [
      {
        id: 'decision-learn-1',
        item: 'Built a full-stack application using Next.js, Prisma, and Clerk authentication.',
      },
      {
        id: 'decision-learn-2',
        item: 'Developed reusable React components with dynamic, real-time UI updates.',
      },
      {
        id: 'decision-learn-3',
        item: 'Implemented a weighted scoring system for decision-making, efficiently handling relational data.',
      },
      {
        id: 'decision-learn-4',
        item: 'Delivered a polished frontend using Tailwind with fully responsive design across devices.',
      },
    ],
    challenges:
      'One key challenge was designing a flexible scoring and weighting system that remained intuitive for the user. Managing all combinations of options and criteria with real-time updates required careful planning and thorough testing. Additionally, integrating secure authentication and handling server-side actions efficiently was essential to ensure a smooth and reliable user experience.',
  },
  // {
  //   id: '2',
  //   title: 'Jobit',
  //   description:
  //     'Jobit is a web-based application for job posting that my team and I created using React and JSearch API. Our platform connects developers with millions of job opportunities for free. Through Jobit, developers can easily search for job postings according to their preferred location, employment type, level, and salary range. The application provides in-depth information about the job postings, including company details, job requirements, and responsibilities. Users can also explore job openings from specific companies and other similar companies based on their search criteria. Moreover, we incorporated a salary estimate feature and included the option to switch between light and dark themes for user convenience.',
  //   role: 'Software Engineer',
  //   textColor: 'text-[#09AB7C]',
  //   color: 'bg-[#09AB7C]',
  //   hoverColor: 'hover:text-[#09AB7C] dark:hover:text-[#09AB7C]',
  //   tech: [
  //     {
  //       id: 'jobit-tech-1',
  //       name: 'React JS',
  //       icon: react,
  //     },
  //     {
  //       id: 'jobit-tech-2',
  //       name: 'Redux Toolkit',
  //       icon: redux,
  //     },
  //     {
  //       id: 'jobit-tech-3',
  //       name: 'Tailwind',
  //       icon: tailwind,
  //     },
  //     {
  //       id: 'jobit-tech-4',
  //       name: 'Git',
  //       icon: git,
  //     },
  //   ],
  //   demoLink: 'https://jobit-react-app.vercel.app',
  //   heroAsset: jobitTop,
  //   problemStatement: {
  //     problem:
  //       'The job market is constantly evolving and highly competitive, making it difficult for job seekers to find the right job and for employers to find the right candidates. This problem is further exacerbated by the sheer volume of job postings available online, making it difficult to find relevant job opportunities.',
  //     solution:
  //       'Jobit aims to solve this problem by providing a modern job posting web application that gives developers free access to millions of job postings and connects them with potential employers. By utilizing the JSearch API, Jobit enables users to search for job opportunities based on specific criteria, providing detailed information about job postings and salary estimates to help job seekers make informed decisions.',
  //   },
  //   problemAsset: jobitProb,
  //   figmaDesign: jobitFigma,
  //   processOverview:
  //     'In developing this application, our team followed the Agile methodology. Agile methodology is a project management process that is primarily used in software development. By following the Agile methodology, we got to develop the app in an iterative manner, became adaptable to change in priorities and was able to work collaboratively and more effectively. The items below are the deliverables delivered in the process.',
  //   definition:
  //     'Our team  gathered and defined the project, its scope and understand the requirements we need to cover.',
  //   planning:
  //     'In this phase, our team collaborated to strategize on the tools and approach we will take. After that we did a backlog grooming, break down tasks into workable items, did estimates and prioritized and assigned tasks accordingly.',
  //   development:
  //     'Having the knowledge on what, why, how and when, we kick-start development. We conducted daily stand-up meetings to share progress, discuss the roadblocks, our current tasks and the next steps. ',
  //   delivery:
  //     'After we covered the project requirements, our team prepared a short presentation to demo the app and its features then deployed the MVP version of product in Vercel for testing and feedback gathering. ',
  //   product: [
  //     {
  //       id: 'jobit-slide-1',
  //       asset: jobitSlide1,
  //     },
  //     {
  //       id: 'jobit-slide-2',
  //       asset: jobitSlide2,
  //     },
  //     {
  //       id: 'jobit-slide-3',
  //       asset: jobitSlide3,
  //     },
  //   ],
  //   learnings: [
  //     {
  //       id: 'jobit-learn-1',
  //       item: 'Acquired skills in rapid and aesthetically pleasing frontend development using Tailwind.',
  //     },
  //     {
  //       id: 'jobit-learn-2',
  //       item: 'Successfully worked and collaborated with an online team consisting of members with different background from different countries.',
  //     },
  //     {
  //       id: 'jobit-learn-3',
  //       item: 'Developed reusable components for efficient software development.',
  //     },
  //     {
  //       id: 'jobit-learn-4',
  //       item: 'Proficiently utilized and integrated JSearch API into the project.',
  //     },
  //   ],
  //   challenges:
  //     "Our team faced several challenges while developing the MVP of Jobit. One of the major obstacles was selecting the appropriate tools from the plethora of options available. As a team, we gathered and weighed the pros and cons before deciding on the project's tech stack. Another significant hurdle was dealing with an inconsistent API, which made it difficult to effectively retrieve and process data. When the API didn't provide complete data, we had to find workarounds, requiring further research and problem-solving skills. Nonetheless, our perseverance enabled us to overcome these challenges and delivered a fully functional web app.",
  // },
  // {
  //   id: '3',
  //   title: 'Morent',
  //   description:
  //     "Morent, a cutting-edge car rental application that was developed using the MERN stack. The app boasts a dynamic homepage that showcases featured vehicles, along with convenient pickup and drop-off location options and a comprehensive list of available cars. My team and I also developed  the car listing page which offers a search bar and various filtering options for users to find the perfect vehicle. Additionally, it has a car details page which provides users with detailed information along with suggestions for other recommended vehicles. Car owners are also able to list their cars for rent through our Add Car page, while users can easily track their rented and rented-out cars through their profile page. Overall, we've created an intuitive and user-friendly MVP version of the platform that will make renting a car a breeze.",
  //   role: 'Software Engineer',
  //   textColor: 'text-[#3563E9]',
  //   color: 'bg-[#3563E9]',
  //   hoverColor: 'hover:text-[#3563E9] dark:hover:text-[#3563E9]',
  //   tech: [
  //     {
  //       id: 'jobit-tech-1',
  //       name: 'Next JS',
  //       icon: nextjs,
  //     },
  //     {
  //       id: 'jobit-tech-2',
  //       name: 'Tailwind',
  //       icon: tailwind,
  //     },
  //     {
  //       id: 'jobit-tech-3',
  //       name: 'Node JS',
  //       icon: nodeJs,
  //     },
  //     {
  //       id: 'jobit-tech-4',
  //       name: 'MongoDB',
  //       icon: mongodb,
  //     },
  //     {
  //       id: 'jobit-tech-5',
  //       name: 'Git',
  //       icon: git,
  //     },
  //   ],
  //   demoLink: 'https://carrent-app.vercel.app',
  //   heroAsset: morentTop,
  //   problemStatement: {
  //     problem:
  //       'One of the main problems that people face when looking to rent a car is the hassle of finding a reliable and user-friendly platform to search for and book rental cars. In addition, car owners who want to rent out their vehicles often struggle to find a suitable platform to list their cars and manage their rentals.',
  //     solution:
  //       'A modern car rental app can solve these problems by offering a user-friendly platform that enables customers to search for available cars and make reservations from the comfort of their own homes. Moreover, the app can provide customers with a wider range of vehicle choices, and car owners can list their cars for rent.  With these features, a modern car rental app can provide a solution that simplifies the car rental process and meets the needs of both renters and car owners.',
  //   },
  //   problemAsset: morentProb,
  //   figmaDesign: morentFigma,
  //   processOverview:
  //     'Our team utilized the Agile methodology in the development of our web application. With this approach, we were able to work collaboratively, prioritize tasks, and deliver frequent iterations of the product. The following are the deliverables and steps we took to develop the application:',
  //   definition:
  //     'In this phase, our team collaborated to identify the project goals, scope, and understand the requirements.',
  //   planning:
  //     'Our team did a brainstorming session to identify the tools and strategy on how we will develop the app. We then break down the work into smaller tasks, estimated effort, and assigned priorities.',
  //   development:
  //     'In this phase, our team works on creating the product and its features iteratively, collaborating with each other and making necessary adjustments along the way.',
  //   delivery:
  //     'We did a short demo and presentation, gathered feedback to ensure that it meets the defined requirements and delivered the MVP version of the product which we developed in just a span of 1 month. ',
  //   product: [
  //     {
  //       id: 'morent-slide-1',
  //       asset: morentSlide1,
  //     },
  //     {
  //       id: 'morent-slide-2',
  //       asset: morentSlide2,
  //     },
  //     {
  //       id: 'morent-slide-3',
  //       asset: morentSlide3,
  //     },
  //   ],
  //   learnings: [
  //     {
  //       id: 'morent-learn-1',
  //       item: 'Gained extensive knowledge of full authentication and authorization implementation, including the use of industry-standard security protocols such as JSON Web Tokens (JWT).',
  //     },
  //     {
  //       id: 'morent-learn-2',
  //       item: 'Sharpened my backend skills, specifically in optimizing database queries, improving performance, and handling server-side logic.',
  //     },
  //     {
  //       id: 'morent-learn-3',
  //       item: "Learned how to properly handle files, including file upload, storage, and retrieval, ensuring that the app's data is organized and easily accessible while keeping it secure.",
  //     },
  //     {
  //       id: 'morent-learn-4',
  //       item: 'Acquire proficiency in NextJS and implement various features  utilizing industry-standard best practices.',
  //     },
  //   ],
  //   challenges:
  //     'As we developed Morent, our team encountered various obstacles. One of our biggest challenges was choosing the right tools and technologies for the project. We conducted brainstorming and carefully weighed our options before making a decision. Furthermore, using NextJS was a new experience for us, and we encountered difficulties while implementing its features. Finally, we had to work under time constraints, which added pressure to the project. However, we collaborated effectively to overcome these obstacles and ultimately delivered a high-quality product within the given timeline.',
  // },
];
